module.exports = "<div class=\"agent-info-component\">\n  <img class=\"avatar\" src=\"{{getAvatar(row.crm_id)}}\" alt=\"\">{{row.crm_username}}\n</div>\n"